module.exports = __webpack_public_path__ + "static/media/google_03.16d532eb.svg";